export default "__VITE_ASSET__5Hi9Nek0__"